// Admin-only onboarding checklist for agent users. Stored at users/{uid}/onboarding/{stepId} = { done, doneAt, doneBy, note }.
// To add a step later, add one object to ONBOARDING_STEPS. `auto(u)` (optional) returns true when the step is met
// from data already in the user record; admins can still tick any step by hand.
export const GOOGLE_TEST_USERS_URL = 'https://console.cloud.google.com/auth/audience?project=resi-3b5fe';
const str = (v) => String(v || '').trim();
export const PROFILE_FIELDS = [['phone', 'phone'], ['title', 'title'], ['websiteUrl', 'website'], ['profilePhotoUrl', 'headshot']];

export const ONBOARDING_STEPS = [
  { id: 'addedInResi', label: 'Added as a user in Resi', auto: () => true },
  { id: 'profileDetails', label: 'Profile details filled (phone, title, website, headshot)',
    auto: (u) => PROFILE_FIELDS.every(([k]) => str(u.profile?.[k])),
    missing: (u) => PROFILE_FIELDS.filter(([k]) => !str(u.profile?.[k])).map(([, l]) => l) },
  { id: 'roleCommission', label: 'Role and commission split set',
    auto: (u) => !!u.role && ['teamSplitPercent', 'brokerSplitPercent', 'agentLeadPercent', 'teamLeadPercent'].some((k) => str(u.commissionSettings?.[k])) },
  { id: 'googleTestUser', label: 'Google email added to Google Cloud test users', kind: 'googleTestUser' },
  { id: 'welcomeEmail', label: 'Welcome email sent', kind: 'welcomeEmail' },
  { id: 'firstSignIn', label: 'Agent signed in for the first time', auto: (u) => !!u.activity?.lastLogin },
  { id: 'calendarConnected', label: 'Google Calendar connected', auto: (u) => u.integrations?.google?.calendar?.status === 'connected' },
];

// Staff roles don't get the agent checklist.
const STAFF = ['Admin', 'TC', 'Local Assistant', 'Marketing Manager', 'Marketing Assistant', 'Closing Concierge'];
export const needsOnboarding = (u) => !!u && !STAFF.includes(u.role);

export function onboardingStatus(u = {}) {
  const saved = u.onboarding || {};
  const steps = ONBOARDING_STEPS.map((s) => {
    const autoDone = s.auto ? !!s.auto(u) : false;
    const rec = saved[s.id] || {};
    return { ...s, autoDone, manualDone: rec.done === true, done: autoDone || rec.done === true, note: rec.note || '', doneAt: rec.doneAt || null, doneBy: rec.doneBy || null };
  });
  const done = steps.filter((s) => s.done).length;
  return { steps, done, total: steps.length, complete: done === steps.length };
}
